function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let menuPosition = offset(document.querySelector('#nav-main'));

if(window.innerWidth > 960){
    window.addEventListener('scroll', function() {
        if(window.scrollY > menuPosition.top){
            document.getElementById('header').classList.add('header--fixed');
            document.getElementById("logo-image").src = 'https://smictom-paysdevilaine.fr/wp-content/themes/smictom-pays-de-vilaine/assets/src/images/sprite-images/Pictos/menu_fixe_home.svg';
        }
        else{
            document.getElementById('header').classList.remove('header--fixed');
            document.getElementById("logo-image").src = 'https://smictom-paysdevilaine.fr/wp-content/themes/smictom-pays-de-vilaine/assets/src/images/sprite-images/Pictos/header_LOGO.svg';
        }
    })
}
